module.exports = __parcel__import__.meta.resolve("5VHUW");